import { proxy } from "valtio";

import { createDefaultState } from "./constants";
import type * as Types from "./types";

export const createState = (initialState?: Partial<Types.State>) => {
  const defaultState = createDefaultState(initialState);
  return proxy<Types.State>(defaultState);
};
